import React from 'react';
import TopNavLayoutNavbarTop from 'components/navbar/top/TopNavLayoutNavbarTop';
import { Outlet } from 'react-router-dom';

import { useAppContext } from 'providers/AppProvider';

const TopNavLayout = () => {
  const {
      config: { isFluid, }
    } = useAppContext();

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
        <div className="content">
          <TopNavLayoutNavbarTop />
          <Outlet />
        </div>
    </div>
  );
};

export default TopNavLayout;
